import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { ReactNode, useRef } from 'react';

import styles from './AccordionItem.module.scss';

interface AccordionItemProps {
    title: string;
    children: ReactNode;
}

const AccordionItem = ({ title, children }: AccordionItemProps) => {
    const ariaHiddenRef = useRef(null);

    return (
        <Accordion
            id={`accordion-${title}`}
            onChange={(event: React.SyntheticEvent, expanded: boolean) => {
                if (ariaHiddenRef) {
                    ariaHiddenRef.current.ariaHidden = !expanded;
                }
            }}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`accordion-${title}`}
                id={`accordion-summary-${title}`}>
                <div className={styles['accordion-title']}>{title}</div>
            </AccordionSummary>
            <AccordionDetails ref={ariaHiddenRef} aria-hidden="true">
                {children}
            </AccordionDetails>
        </Accordion>
    );
};

export default AccordionItem;
